export const ADD = 'ADD';
export const Initial = 'Initial';
